export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach(param => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

// 充值地址
const VUE_APP_CHARGE_URL= "https://api.hdmingpinmall.com/api/toPay";

const VUE_GAME_ASSETS_URL = `http://game.hdmingpinmall.cn`;
// const VUE_APP_API_URL = `https://admin.mingpinjixuan.com/api`;
const VUE_APP_API_URL = `https://api.hdmingpinmall.com/api`;
const VUE_APP_WS_URL =  `ws:admin.mingpinjixuan.com:10003`;
const VUE_APP_VERSION = "3.5.35";

// const VUE_GAME_ASSETS_URL = process.env.VUE_GAME_ASSETS_URL || `http://mpjxt.phasercn.com`;
// const VUE_APP_API_URL = `http://crmeb.test/api`;
// const VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || `ws:mpjxt.phasercn.com:10003`;
// const VUE_APP_VERSION = "3.5.35";

// const VUE_APP_API_URL = "https://admin.mingpinjixuan.com/api";
// const VUE_APP_WS_URL = "ws:mpjx.phasercn.com:20003";
// const VUE_APP_API_URL = "http://crmeb.test/api";
// const VUE_APP_WS_URL = "ws:crmeb.test:20003";
export { VUE_APP_API_URL, VUE_APP_WS_URL, VUE_APP_VERSION,VUE_GAME_ASSETS_URL,VUE_APP_CHARGE_URL };


// Nginx 跨域配置
// location ~ .*\.(gif|jpg|jpeg|png|bmp|swf|mp3)$
// {        
//     expires      30d;
//     error_log off;
//     access_log /dev/null;
//     #设置静态资源可以跨域
//     add_header 'Access-Control-Allow-Origin' *;
//     add_header 'Access-Control-Allow-Credentials' 'true';
//     add_header 'Access-Control-Allow-Methods' *;
// }